import { IAAPDDentist } from '../../classes/dentist';

export enum ActionType {
    REQUEST_NEXT_BATCH,
    RECIEVE_NEXT_BATCH,
    SET_CONTENT,
    SET_PAGE,
    REQUEST_SETTINGS,
    RECIEVE_SETTINGS,
    CLEAR_RESULTS,
    UPDATE_TEXT_FILTER,
    UPDATE_NUMBER_FILTER
};

export function updateTextFilter(filterName: string, filterValue: string) {
    return {
        type: ActionType.UPDATE_TEXT_FILTER,
        value: {
            filterName: filterName,
            filterValue: filterValue
        }
    }
}

export function updateNumberFilter(filterName: string, filterValue: number) {
    return {
        type: ActionType.UPDATE_NUMBER_FILTER,
        value: {
            filterName: filterName,
            filterValue: filterValue
        }
    }
}

export function setContent(content: IAAPDDentist) {
    return {
        type: ActionType.SET_CONTENT,
        value: content
    }
}

export function setPage(page: number) {
    return {
        type: ActionType.SET_PAGE,
        value: page
    }
}




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/actions/actions.ts